import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import imgLogo from 'src/assets/images/618-logo.svg';

const ThankYou = () => (
  <Root>
    <img src={imgLogo} alt="618 Carnarvon" />
    <h1>Thank you</h1>
    <p>Thank you for your interest in 618 Carnarvon.</p>
    <p>
      By registering, you will be the first to receive the latest updates about
      this exciting project.
    </p>
    <Button to="/">Back to Home</Button>
  </Root>
);

export default ThankYou;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  h1 {
    text-transform: uppercase;
    margin: 20px 0;
  }
  p {
    font-family: ${({ theme }) => theme.fontMain};
    color: rgba(0, 0, 0, 0.72);
    font-size: 18px;
    letter-spacing: 0;
    line-height: 24px;
    margin-bottom: 20px;
    text-align: center;
  }
`;

const Button = styled(Link)`
  background-color: white;
  border-radius: 17.5px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  padding: 10px 26px;
  color: rgba(0, 0, 0, 0.83);
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 12px;
  text-transform: uppercase;
  transition: 0.3s ease;
  &:hover {
    background-color: ${({ theme }) => theme.colorPrimary};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/ThankYou.js